const searchFacetSelectJsClass = 'js-search-facet-select';
const selectJsClass = searchFacetSelectJsClass + '-select';

const searchFacetSelectElements = document.querySelectorAll('.' + searchFacetSelectJsClass);

if (searchFacetSelectElements.length > 0) {
    searchFacetSelectElements.forEach((searchFacetSelectElement) => {
        // Get the select element
        const selectElement = searchFacetSelectElement.querySelector('.' + selectJsClass) as HTMLSelectElement;

        if (selectElement) {
            // Add a change event listener
            selectElement.addEventListener('change', () => {
                // If the option has a value
                if (selectElement.value) {
                    // Navigate to the url in the value
                    window.location.href = selectElement.value;
                }
            });
        }
    });
}